export const authType = {
  SAVE_SETTINGS: "SAVE_SETTINGS",
  CLEAR_SETTINGS: "CLEAR_SETTINGS",
  LOG_OUT: "LOG_OUT",
};
